import { TemperatureType } from '@core/referential/temperature-type.enum'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { Permission } from '@/lib/permissions'

const SearchSchema = z.object({
  temperatureType: z.nativeEnum(TemperatureType).default(TemperatureType.RADIATOR),
})

export const Route = createFileRoute('/_dashboard/site/$id/comfort/monitoring/$floorId/')({
  validateSearch: SearchSchema,
  beforeLoad({ context }) {
    if (!context.user?.hasPermission(Permission.EDIT_FLOOR_PLAN)) {
      throw redirect({ to: '/403' })
    }
  },
})
